<template>
  <q-dialog ref="processDialog"
            class="bs bs-q-dialog bs-q-dialog-ongoing bs-q-dialog-progress"
            v-model="showDialog"
            prevent-close
            stack-buttons
            @show="onShow"
            @hide="onHide">
    <div slot="body">
      <div class="dialog-body-group">
        <div class="contents-row">
          <p class="dialog-body-ico">
            <q-knob v-model="currentProcess"
                    style="width: 56px; height: 56px;"
                    class="bs bs-q-knob bs-q-knob-default text-primary"
                    readonly
                    :min="0"
                    :max="totalProcess"
                    :step="10"></q-knob>
          </p>
          <p>
            {{ topMsg }}
          </p>
          <p>
            {{ bottomMsg }} : {{ `${currentProcess} / ${totalProcess}` }}
          </p>
        </div>
      </div>
    </div>

    <template slot="buttons"
              slot-scope="props">
      <q-toolbar slot="footer">
        <div class="contents-row">
          <div class="footer-option-group">
            <div class="row bs-q-btn-dialog-group">
              <q-btn class="bs bs-q-btn-xs bs-q-btn-icon bs-q-btn-popup-line"
                     outline="outline"
                     :label="btnText"
                     :auth-force="true"
                     @click="$emit('cancel')"></q-btn>
            </div>
          </div>
        </div>
      </q-toolbar>
    </template>
  </q-dialog>
</template>

<script>
  export default {
    name: 'ProcessDialog',
    components: {},
    directives: {},
    mixins: [],
    data () {
      return {
        showDialog: false
      }
    },
    props: {
      topMsg: {
        type: String,
        default: ''
      },
      btnText: {
        type: String,
        default: ''
      },
      bottomMsg: {
        type: String,
        default: ''
      },
      totalProcess: {
        type: Number,
        default: 0
      },
      currentProcess: {
        type: Number,
        default: 0
      }
    },
    computed: {},
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      show () {
        this.showDialog = true
        this.$refs.processDialog.show()
      },
      hide () {
        this.showDialog = false
        this.$refs.processDialog.hide()
      },
      onHide () {
        this.$emit('hide')
      },
      onShow () {
        this.$emit('show')
      },
      getShowState () {
        return this.showDialog
      }
    },
    watch: {}
  }
</script>

<style scoped>

</style>
